/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBackslash = createReactComponent("backslash", "IconBackslash", [
  ["path", { d: "M7 5l10 14", key: "svg-0" }]
]);

export { IconBackslash as default };
//# sourceMappingURL=IconBackslash.js.map
